module.exports = __webpack_public_path__ + "img/pick2.caec45ed.png";